import React from 'react';
import styled from "styled-components";
import PropTypes from "prop-types";
import {ESCAPE} from '../constants/keys'

import ClearIcon from '../../components/icons/ClearIcon';

const ModalRit = styled.div`
    border-radius: 4px;
    box-shadow: -2px 2px 10px 0 rgba(102, 116, 166, 0.2);
    padding: 20px 25px 25px;
    background-color: #fff;
    color: #444;
    width: 50%;
    max-width: 750px;
    min-width: 355px;
`;

const Backdrop = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    background-color: rgba(255, 255, 255, 0.80);
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Header = styled.div`
    display: flex;
    margin: 0 0 15px;
    align-items: center;
`;

const Title = styled.div`
    margin: 0 15px 0 0;
    text-transform: uppercase;
    font-size: 1.25em;
`;

const CloseButton = styled.button`
    padding: 5px;
    margin: 0 0 0 auto;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
    cursor: pointer;
    outline: none;
`;

const Description = styled.div`
    margin-top: 15px;
    color: #777;
    text-align: left;
`;

export default class SizeMediaModal extends React.Component {
    constructor() {
        super();
        this.state = {}
    }

    componentDidMount() {
        if (this.props.closeOnEsc) {
            window.addEventListener('keydown', this.onKeyDownClose)
        }
    }

    componentWillUnmount() {
        if (this.props.closeOnEsc) {
            window.removeEventListener('keydown', this.onKeyDownClose)
        }
    }

    onKeyDownClose = event => {
        if (event.keyCode === ESCAPE) this.props.onClose()
    }

    render() {
        const { title, onClose, mediaUrl, description } = this.props;

        let videoFrame;
        if (mediaUrl) {
            videoFrame = (
                <iframe
                    width='100%'
                    height='315'
                    src={mediaUrl}
                    frameBorder='0'
                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;'
                    allowFullScreen
                />
            );
        };

        return (
            <React.Fragment>
                <Backdrop onClick={onClose}>
                    <ModalRit>
                        <Header>
                            <Title>
                                {title}
                            </Title>
                            <CloseButton
                                onClick={onClose}
                            >
                                <ClearIcon style={{ width: '1em', height: '1em' }} />
                            </CloseButton>
                        </Header>
                        {videoFrame}
                        <Description>
                            {description}
                        </Description>
                    </ModalRit>
                </Backdrop>
            </React.Fragment>
        )
    }
}

SizeMediaModal.propTypes = {
    title: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    mediaUrl: PropTypes.string,
    description: PropTypes.string,
};
